import { FormControl, FormGroup, Validators } from '@angular/forms';

import { AdministrationGroupFacultyRestriction } from '../../../../../types';
import { FacultyRestrictionItem } from '../types';
import { DEFAULT_RESTRICTION_UNIT } from '../faculties-selection-list/faculties-selection-list-item/constants';
import { GENERIC_UNIT } from '../../../../../constants/restriction';

export const createRestrictionFormGroup = (
  restriction?: AdministrationGroupFacultyRestriction,
): FacultyRestrictionItem => {
  const formGroup = new FormGroup({
    value: new FormControl(restriction?.value || null, [
      Validators.required,
      Validators.min(0),
    ]),
    unit: new FormControl(
      restriction?.unit || DEFAULT_RESTRICTION_UNIT,
      Validators.required,
    ),
  });

  // Deshabilitar controles si es una restricción no editable
  const unitValue = restriction?.unit;
  if (
    unitValue === GENERIC_UNIT.EXPIRATION_DATE ||
    unitValue === GENERIC_UNIT.LOCALITY
  ) {
    formGroup.controls.unit.disable({ emitEvent: false });
    formGroup.controls.value.disable({ emitEvent: false });
  }

  return formGroup;
};
